import * as DoctorAction from '../actions/list.actions';

const defaultFilter = {
  textSearch: '',
};

const initialState = {
  error: null,
  message: 'LIST_EMPTY_MESSAGE',
  filter: defaultFilter,
  submitting: false,
};

const list = (state = initialState, action) => {
  switch (action.type) {
    case DoctorAction.SET_DOCTORS_FILTER: {
      return { ...state, filter: action.payload.filter };
    }
    case DoctorAction.RESET_DOCTORS_FILTER: {
      return { ...state, filter: defaultFilter };
    }
    case DoctorAction.REMOVE_DOCTOR: {
      return { ...state, submitting: true };
    }
    case DoctorAction.REMOVE_DOCTOR_SUCCESS: {
      return { ...state, submitting: false };
    }
    case DoctorAction.REMOVE_DOCTOR_FAIL: {
      return { ...state, submitting: false, error: action.payload.error, message: action.payload.message };
    }
    default: {
      return state;
    }
  }
};

export default list;
